import React from "react";

export function Logo({ size = "md" }) {
  const h = size === "lg" ? "h-12" : size === "sm" ? "h-7" : "h-9";
  return (
    <div className="flex items-center gap-2.5" data-testid="brand-logo">
      <div className="bg-white rounded-xl px-2.5 py-1.5 flex items-center shadow-md">
        <img src="/omaxe-logo.webp" alt="Omaxe Chowk" className={`${h} w-auto object-contain`} />
      </div>
      <div className="leading-none hidden sm:block">
        <div className="font-display font-extrabold text-slate-50 text-sm tracking-tight">Dawatpur Food Court</div>
        <div className="flex items-center gap-1.5 mt-1">
          <span className="text-[9px] tracking-[0.18em] text-blue-200/70 font-medium">POWERED BY</span>
          <img src="/fundle-white.png" alt="Fundle.ai" className="h-3 w-auto object-contain" />
        </div>
      </div>
    </div>
  );
}

export function PoweredBy({ className = "" }) {
  return (
    <div className={`flex items-center justify-center gap-2 py-5 ${className}`} data-testid="powered-by-fundle">
      <span className="text-[11px] tracking-[0.18em] text-blue-200/60">POWERED BY</span>
      <img src="/fundle-white.png" alt="Fundle.ai" className="h-4 w-auto object-contain" />
    </div>
  );
}
